import React, {Component} from 'react';
import AnswersQuestionsComponent from './AnswersQuestionsComponent'

class SectionFAQ extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <dl className="faq__section">
                <h2>{this.props.section.Title.Value}</h2>
                {this.props.section.AnswersQuestions.map((AnswersQuestions) => {
                    return <AnswersQuestionsComponent answersQuestions={AnswersQuestions}  />
                })}
            </dl>
        )
    }
}
export default SectionFAQ ;
